import React from 'react'
import { TextField, Show, Labeled, DateField, ChipField, FunctionField } from 'react-admin'
import { Grid } from '@mui/material'
import ColoredLeadPropertyStatusField from '../../../../components/ColoredLeadPropertyStatusField'

export const ShowContact = (props) => {
  return (
    <Show actions="" {...props}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Labeled source="id" label="ID">
            <TextField source="id" label="ID" />
          </Labeled>
        </Grid>
        <Grid item xs={12} md={6}>
          <Labeled source="phone_no" label="Phone Number">
            <TextField source="phone_no" />
          </Labeled>
        </Grid>
        <Grid item xs={12} md={6}>
          <Labeled source="email" label="Email">
            <TextField source="email" />
          </Labeled>
        </Grid>
        <Grid item xs={12} md={6}>
          <Labeled source="name" label="Name">
            <TextField source="name" />
          </Labeled>
        </Grid>
        <Grid item xs={12} md={6}>
          <Labeled source="city" label="City">
            <TextField source="city" />
          </Labeled>
        </Grid>
        <Grid item xs={12} md={6}>
          <Labeled source="category" label="Category">
            <TextField source="category" />
          </Labeled>
        </Grid>
        <Grid item xs={12} md={6}>
          <Labeled source="source" label="Source">
            <ChipField size="small" source="source" />
          </Labeled>
        </Grid>
        <Grid item xs={12} md={6}>
          <Labeled source="status" label="Status">
            <FunctionField
              source="status"
              sortable={false}
              render={(record, source) => <ColoredLeadPropertyStatusField record={{ ...record }} source={source} />}
            />
          </Labeled>
        </Grid>
        <Grid item xs={12} md={6}>
          <Labeled source="worked_by" label="Worked By">
            <TextField source="worked_by" />
          </Labeled>
        </Grid>
        <Grid item xs={12} md={6}>
          <Labeled source="created_at" label="Created At">
            <DateField showTime={true} source="created_at" />
          </Labeled>
        </Grid>
      </Grid>
    </Show>
  )
}
